import { ViewModel } from 'view_models/view_model'
import { Vendor } from 'entities/vendor'
import { AddressViewModel } from './address_view_model'

export class VendorViewModel extends ViewModel<Vendor> {
    public contractDateText = (): string => {
        return this.toDateText(this.object.contractDate)
    }
    public addressVm = (): AddressViewModel => {
        return new AddressViewModel(this.object.address!)
    }
}
